import _ from 'lodash';
import * as actions from 'app/actions/legal';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_WARRANTY_PAGE: {
      return Object.assign({}, state, {
        warrantyPage: _.find(action.result, { fields: { type: 'warranty' } }),
      });
    }
    case actions.SET_PATENT_PAGE: {
      return Object.assign({}, state, {
        patentPage: _.find(action.result, { fields: { type: 'patents' } }),
      });
    }
    case actions.SET_LEGAL_PAGES: {
      return Object.assign({}, state, {
        privacyPage: _.find(action.result, { fields: { type: 'privacy' } }),
        patentPage: _.find(action.result, { fields: { type: 'patents' } }),
        warrantyPage: _.find(action.result, { fields: { type: 'warranty' } }),
        termsOfServicePage: {
          ..._.find(action.result, { fields: { type: 'termsOfService' } }).fields,
          minorVersion: _.find(action.result, { fields: { type: 'termsOfService' } }).sys.revision,
        },
      });
    }
    case actions.SET_TOS_PAGE: {
      return Object.assign({}, state, {
        termsOfServicePage: {
          ..._.find(action.result, { fields: { type: 'termsOfService' } }).fields,
          minorVersion: _.find(action.result, { fields: { type: 'termsOfService' } }).sys.revision,
        },
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/legal.js